/**
 * Cash Out Configuration
 * 
 * Feature flags and settings for the dual cash-out system
 */

// Feature flag - flip to true when off-ramp provider is ready
export const OFF_RAMP_WIDGET_ENABLED = false;

// Exchange directory by country/region
export const EXCHANGES_BY_COUNTRY = {
  // North America
  "US": [
    { name: "Coinbase", url: "https://www.coinbase.com", description: "Beginner friendly, easy bank withdrawals", popular: true },
    { name: "Kraken", url: "https://www.kraken.com", description: "Low fees, trusted exchange" },
    { name: "Gemini", url: "https://www.gemini.com", description: "Regulated US exchange" }
  ],
  "CA": [
    { name: "Coinbase", url: "https://www.coinbase.com", description: "CAD withdrawals supported", popular: true },
    { name: "Kraken", url: "https://www.kraken.com", description: "CAD bank transfers" },
    { name: "Newton", url: "https://www.newton.co", description: "Canadian exchange, no fees" }
  ],
  
  // Latin America
  "MX": [
    { name: "Bitso", url: "https://www.bitso.com", description: "Most popular in Mexico, MXN withdrawals", popular: true },
    { name: "Binance P2P", url: "https://p2p.binance.com", description: "Peer-to-peer, best rates" }
  ],
  "BR": [
    { name: "Mercado Bitcoin", url: "https://www.mercadobitcoin.com.br", description: "Largest in Brazil, BRL support", popular: true },
    { name: "Binance P2P", url: "https://p2p.binance.com", description: "BRL peer-to-peer trading" }
  ],
  "AR": [
    { name: "Binance P2P", url: "https://p2p.binance.com", description: "ARS peer-to-peer trading", popular: true },
    { name: "Ripio", url: "https://www.ripio.com", description: "Popular in Argentina" }
  ],
  "CO": [
    { name: "Binance P2P", url: "https://p2p.binance.com", description: "COP peer-to-peer trading", popular: true },
    { name: "Buda", url: "https://www.buda.com", description: "Colombian pesos supported" }
  ],
  
  // Europe
  "GB": [
    { name: "Coinbase", url: "https://www.coinbase.com", description: "GBP Faster Payments", popular: true },
    { name: "Kraken", url: "https://www.kraken.com", description: "GBP bank transfers" },
    { name: "Bitstamp", url: "https://www.bitstamp.net", description: "EU regulated, GBP support" }
  ],
  "DE": [
    { name: "Kraken", url: "https://www.kraken.com", description: "EUR SEPA transfers", popular: true },
    { name: "Bitstamp", url: "https://www.bitstamp.net", description: "EU regulated exchange" },
    { name: "Coinbase", url: "https://www.coinbase.com", description: "Easy EUR withdrawals" }
  ],
  "FR": [
    { name: "Coinbase", url: "https://www.coinbase.com", description: "EUR SEPA transfers", popular: true },
    { name: "Kraken", url: "https://www.kraken.com", description: "Low fees, EUR support" }
  ],
  "ES": [
    { name: "Coinbase", url: "https://www.coinbase.com", description: "EUR SEPA transfers", popular: true },
    { name: "Bit2Me", url: "https://www.bit2me.com", description: "Spanish exchange" }
  ],
  "IT": [
    { name: "Coinbase", url: "https://www.coinbase.com", description: "EUR SEPA transfers", popular: true },
    { name: "Young Platform", url: "https://www.youngplatform.com", description: "Italian exchange" }
  ],
  "NL": [
    { name: "Bitvavo", url: "https://www.bitvavo.com", description: "Dutch exchange, EUR support", popular: true },
    { name: "Coinbase", url: "https://www.coinbase.com", description: "EUR SEPA transfers" }
  ],
  "PL": [
    { name: "Binance", url: "https://www.binance.com", description: "PLN support via P2P", popular: true },
    { name: "Coinbase", url: "https://www.coinbase.com", description: "EUR withdrawals" }
  ],
  
  // Asia
  "PH": [
    { name: "Coins.ph", url: "https://www.coins.ph", description: "Most popular in Philippines, PHP", popular: true },
    { name: "Binance P2P", url: "https://p2p.binance.com", description: "PHP peer-to-peer" },
    { name: "PDAX", url: "https://www.pdax.ph", description: "Philippine exchange" }
  ],
  "IN": [
    { name: "WazirX", url: "https://www.wazirx.com", description: "Popular in India, INR support", popular: true },
    { name: "CoinDCX", url: "https://www.coindcx.com", description: "INR bank transfers" },
    { name: "Binance P2P", url: "https://p2p.binance.com", description: "INR peer-to-peer" }
  ],
  "ID": [
    { name: "Indodax", url: "https://www.indodax.com", description: "Largest in Indonesia, IDR", popular: true },
    { name: "Tokocrypto", url: "https://www.tokocrypto.com", description: "Indonesian exchange" }
  ],
  "TH": [
    { name: "Bitkub", url: "https://www.bitkub.com", description: "Largest in Thailand, THB", popular: true },
    { name: "Binance P2P", url: "https://p2p.binance.com", description: "THB peer-to-peer" }
  ],
  "VN": [
    { name: "Binance P2P", url: "https://p2p.binance.com", description: "VND peer-to-peer trading", popular: true },
    { name: "Remitano", url: "https://www.remitano.com", description: "P2P platform, VND support" }
  ],
  "MY": [
    { name: "Luno", url: "https://www.luno.com", description: "MYR bank transfers", popular: true },
    { name: "Binance P2P", url: "https://p2p.binance.com", description: "MYR peer-to-peer" }
  ],
  "SG": [
    { name: "Coinbase", url: "https://www.coinbase.com", description: "SGD support", popular: true },
    { name: "Gemini", url: "https://www.gemini.com", description: "Singapore regulated" }
  ],
  "JP": [
    { name: "bitFlyer", url: "https://www.bitflyer.com", description: "Largest in Japan, JPY", popular: true },
    { name: "Coincheck", url: "https://www.coincheck.com", description: "Japanese exchange" }
  ],
  "KR": [
    { name: "Upbit", url: "https://www.upbit.com", description: "Largest in Korea, KRW", popular: true },
    { name: "Bithumb", url: "https://www.bithumb.com", description: "Korean exchange" }
  ],
  
  // Middle East
  "AE": [
    { name: "Binance", url: "https://www.binance.com", description: "AED support available", popular: true },
    { name: "BitOasis", url: "https://www.bitoasis.net", description: "UAE-based exchange" }
  ],
  "SA": [
    { name: "Binance P2P", url: "https://p2p.binance.com", description: "SAR peer-to-peer", popular: true },
    { name: "Rain", url: "https://www.rain.com", description: "Middle East exchange" }
  ],
  "TR": [
    { name: "BtcTurk", url: "https://www.btcturk.com", description: "Largest in Turkey, TRY", popular: true },
    { name: "Paribu", url: "https://www.paribu.com", description: "Turkish exchange" }
  ],
  
  // Africa
  "NG": [
    { name: "Quidax", url: "https://www.quidax.com", description: "Nigerian Naira support", popular: true },
    { name: "Binance P2P", url: "https://p2p.binance.com", description: "NGN peer-to-peer" },
    { name: "Luno", url: "https://www.luno.com", description: "NGN bank transfers" }
  ],
  "ZA": [
    { name: "Luno", url: "https://www.luno.com", description: "Most popular in SA, ZAR", popular: true },
    { name: "VALR", url: "https://www.valr.com", description: "South African exchange" }
  ],
  "KE": [
    { name: "Binance P2P", url: "https://p2p.binance.com", description: "KES peer-to-peer", popular: true },
    { name: "Paxful", url: "https://www.paxful.com", description: "P2P, M-Pesa support" }
  ],
  "GH": [
    { name: "Binance P2P", url: "https://p2p.binance.com", description: "GHS peer-to-peer", popular: true },
    { name: "Quidax", url: "https://www.quidax.com", description: "GHS support" }
  ],
  
  // Oceania
  "AU": [
    { name: "Coinbase", url: "https://www.coinbase.com", description: "AUD bank transfers", popular: true },
    { name: "Swyftx", url: "https://www.swyftx.com", description: "Australian exchange" },
    { name: "Independent Reserve", url: "https://www.independentreserve.com", description: "AUD support" }
  ],
  "NZ": [
    { name: "Easy Crypto", url: "https://www.easycrypto.com", description: "NZD bank transfers", popular: true },
    { name: "Coinbase", url: "https://www.coinbase.com", description: "NZD support" }
  ],
  
  // Default fallback for unrecognized countries
  "DEFAULT": [
    { name: "Binance", url: "https://www.binance.com", description: "Global exchange, 150+ countries", popular: true },
    { name: "Coinbase", url: "https://www.coinbase.com", description: "Available in 100+ countries" },
    { name: "Kraken", url: "https://www.kraken.com", description: "Trusted global exchange" },
    { name: "Binance P2P", url: "https://p2p.binance.com", description: "Peer-to-peer, local currencies" }
  ]
};

// EU countries that share similar exchange options
export const EU_COUNTRIES = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];

// Get exchanges for a country code
export const getExchangesForCountry = (countryCode) => {
  const code = countryCode?.toUpperCase();
  
  // Check direct match first
  if (EXCHANGES_BY_COUNTRY[code]) {
    return EXCHANGES_BY_COUNTRY[code];
  }
  
  // Check if EU country without specific listing
  if (EU_COUNTRIES.includes(code)) {
    return [
      { name: "Kraken", url: "https://www.kraken.com", description: "EUR SEPA transfers", popular: true },
      { name: "Coinbase", url: "https://www.coinbase.com", description: "EUR bank transfers" },
      { name: "Bitstamp", url: "https://www.bitstamp.net", description: "EU regulated exchange" }
    ];
  }
  
  // Return default
  return EXCHANGES_BY_COUNTRY["DEFAULT"];
};

// Alternative spending options (not exchanges)
export const SPENDING_OPTIONS = [
  {
    name: "Bitrefill",
    url: "https://www.bitrefill.com",
    description: "Buy gift cards for Amazon, Uber, and more",
    icon: "gift"
  }
];

// CoinGecko API for rates (free, no key needed)
export const COINGECKO_API = "https://api.coingecko.com/api/v3";
